import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { parseISO } from 'date-fns';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function DateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={
        filters.create_time__gte === undefined
        && filters.create_time__lt === undefined
      }
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__gte"
          isClearable
          label={t('create_time__gte')}
          name="create_time__gte"
          onChange={([create_time__gte]: Date[]) => updateFilters({
            create_time__gte: create_time__gte?.toISOString(),
          })}
          options={START_OF_DAY}
          value={filters.create_time__gte ? parseISO(filters.create_time__gte) : ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__lt"
          isClearable
          label={t('create_time__lt')}
          name="create_time__lt"
          onChange={([create_time__lt]: Date[]) => updateFilters({
            create_time__lt: create_time__lt?.toISOString(),
          })}
          options={END_OF_DAY}
          value={filters.create_time__lt ? parseISO(filters.create_time__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const DateFilterPopoverWithRef = forwardRef(DateFilterPopover);
export { DateFilterPopoverWithRef as DateFilterPopover };
